import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useHistory, Link } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js';
import DataTable from 'react-data-table-component';
import ReactHtmlParser from 'react-html-parser';

import EntriesSelector from '../Pagination/EntriesSelector';

import {
  statisticsAction,
  statisticsCloseAction
} from '../../actions/settingsAction.js';

const Listpermission = (props) => {

  const { fixNavbar } = props;
  const history = useHistory();

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  /* ---------------- FETCH DATA ---------------- */
  useEffect(() => {
    axios.get(API_BASE_URL + '/floor_permission', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
      .then(res => {
        setData(res.data || []);
      })
      .catch(err => {
        toast.error(
          err?.response?.data?.message || "Failed to load permission list",
          { position: "bottom-right", theme: "colored" }
        );
      });
  }, []);

  /* ---------------- SEARCH FILTER ---------------- */
  const filteredItems = data.filter(item =>
    `${item.employee_id ?? ''} ${item.full_name ?? ''} ${item.department ?? ''}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ---------------- DATATABLE COLUMNS ---------------- */
  const columns = [
    {
      name: 'Action',
      cell: row =>
        row.incharge_id == 1 ? (
          <Link to={`/floor-permission-details?id=${row.id}`}>
            <i className="fe fe-maximize" />
          </Link>
        ) : null,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Employee Id',
      selector: row => row.employee_id,
      sortable: true,
    },
    {
      name: 'Employee',
      selector: row => row.full_name,
      sortable: true,
    },
    {
      name: 'Department',
      selector: row => row.department,
      sortable: true,
    },
    {
      name: 'Permission Date',
      selector: row => row.permission_date,
      sortable: true,
    },
    {
      name: 'Permission Hour',
      selector: row => row.permission_hours,
      sortable: true,
    },
    {
      name: 'Applied On',
      selector: row => row.applied_on,
      sortable: true,
    },
    {
      name: 'Reason',
      selector: row => row.reason,
      wrap: true,
    },
    {
      name: 'Incharge',
      cell: row => ReactHtmlParser(row.incharge),
    },
    {
      name: 'HOD',
      cell: row => ReactHtmlParser(row.dept),
    },
    {
      name: 'HR',
      cell: row => ReactHtmlParser(row.hr_status),
    },
  ];

  return (
    <>
      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <ToastContainer />

        <div className="container-fluid">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="card-title" style={{ color: '#e96827' }}>
                Permission List
              </h3>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                />

                <div style={{ position: "relative", width: "250px", marginLeft: "15px" }}>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                  />
                  {searchTerm && (
                    <span
                      onClick={() => setSearchTerm("")}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#999"
                      }}
                    >
                      ✖
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredItems}
                pagination
                paginationPerPage={entriesPerPage}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                striped
                highlightOnHover
                responsive
                persistTableHead
                noDataComponent="No permission records found"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
  statisticsOpen: state.settings.isStatistics,
  statisticsClose: state.settings.isStatisticsClose,
});

const mapDispatchToProps = (dispatch) => ({
  statisticsAction: (e) => dispatch(statisticsAction(e)),
  statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Listpermission);
